import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification, Modal } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faThumbsDown, faThumbsUp, faTrash, faEllipsis, faCloudDownload, faCheckCircle, faExclamationCircle, faRefresh } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../../DashBaord/Top_navbar";
import ShowData from "../../../../components/ShowData";
import { Link, useLocation } from "react-router-dom";
import { formatProjectDate } from "../../../../controllers/common";
import moment from "moment";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import { list, deleteData, changeStatus, reverseRedeemTicket } from "../../../../controllers/V1/lottoWinners/lottoWinnersControllers";
import { getPage } from "../../../../controllers/common";

import ExportPopup from "./Export";

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const location = useLocation();
  const state = location.state;
  const [batchData, setbatchData] = useState(state || {})
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          batch_id : batchData?.batch_id,
          ...(filter?.filter_by === 'batch_id' && {batch_id : parseInt(filter?.search) }),
          ...(filter?.filter_by === 'order_no' && {order_no : { $regex: filter?.search, $options: "i" }}),

          ...(filter?.filter_by === 'seller_first_name' && {seller_first_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'seller_last_name' && {seller_last_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'seller_mobile' && {seller_mobile : { $regex: filter?.search, $options: "i" } }),

          ...(filter?.filter_by === 'coupon_code' && {coupon_code : filter?.search }),
          ...(filter?.filter_by === 'matching_code' && {matching_code : { $regex: filter?.search, $options: "i" } }),

          ...(filter?.filter_by === 'winner_type'&&{winner_type : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'winning_amount'?{winning_amount : parseInt(filter?.search) }:null),
          
          ...(filter?.from?{createdAt : {$gte : new Date(`${filter.from} 0:01:00`), $lte : new Date(`${filter.from} 23:59:00`)} }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalDataCount(listData?.count);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Orbit Kuwait || Lotto Winner's redeemed list";
  }, [currentPage, showRequest, filter, LIMIT]);

  const handleChangeStatus = async (id = '', status = '') =>{
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Data not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else if(!status){
        notification.open({
          message: "Oops!",
          description: `Status not pass.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else {
        const option ={ id : id, status : status };
        const res = await changeStatus(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Data updated successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      
    }
  }
  const handleReverse = async (id="") => {
    try {
      setIsLoading(true);
      const res = await reverseRedeemTicket({id : id});
      if(res.status === true){
          notification.open({
            message: "Success",
            description: `Winner reverse successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
    } catch (error) {
       setIsLoading(false);
      console.log("[ERROR-Reverse Winning Ticket] : ", error)
    } finally {
      getList();
    }
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={`Winner's redeemed list`}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setShowRequest("");
                      }}
                    />
                    <Tab
                      label="Active"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setShowRequest("Active");
                      }}
                    />
                    <Tab
                      label="Redeemed"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setShowRequest("Redeemed");
                      }}
                    />
                    <Tab
                      label="Expired"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setSkip(0);
                        setShowRequest("Expired");
                      }}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT}/>
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>

                  <div className="inventory_filter_div" onClick={handleExportDrawer}>
                    <FontAwesomeIcon icon={faCloudDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Export
                    </Link>
                  </div>
                  <div className="inventory_filter_div"> 
                    <Link to={false} onClick={()=>getList()}><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>
                </div>
              </div>
            </Box>       
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Batch No.</th>
                              <th>Order No.</th>
                              <th>Seller's Details</th>
                              <th>Coupon Code</th>
                              <th>Matching Code</th>
                              <th>Game Type</th>
                              <th>Winner Type</th>
                              <th>Winning Amount</th>
                              <th>Created Date & Time</th>
                              <th>Status</th>
                              <th>Redeem Details</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td> {SKIP + index + 1} </td>
                                    <td>{items?.batch_id}</td>
                                    {items.status === 'Redeemed' ? (
                                      <td>{items?.order_no}</td>
                                    ):(
                                      <td>{`EDDCXXXXXXXXXXXXXX`}</td>
                                    )}
                                    <td>
                                      Name : {`${items?.seller_first_name} ${items?.seller_last_name}`} <br/>
                                      Ph. No : {items?.seller_mobile}
                                    </td>

                                    <td>{items?.coupon_code}</td>
                                    <td>{items?.matching_code}</td>
                                    <td>
                                      {items?.straight_amount > 0 && 'Straight'}
                                      {items?.rumble_amount > 0 && 'Rumble'}
                                      {items?.chance_amount > 0 && 'Chance'}
                                    </td>
                                    <td>{items?.winner_type || 'N/A'}</td>
                                    <td>
                                      {items?.winning_amount?.toFixed(2) || 0}
                                    </td>
                                    <td>{moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY hh:mm A')}</td>
                                    <td> {items?.status || '-'} </td>
                                    {items.status === 'Redeemed' ? (
                                      <td>
                                        <p>Name : {items?.redeem_name}</p>
                                        <p>Date : {moment(formatProjectDate(items?.redeem_date)).format('DD-MM-YYYY hh:mm A')}</p>
                                        <p>POS : {items?.redeem_pos}</p>
                                      </td>
                                    ):(
                                      <td>-</td>
                                    )}
                                    <td>
                                      {(items?.status === 'Active' || items?.status === 'Redeemed')?(
                                        <Dropdown
                                          placement="bottomLeft"
                                          arrow
                                          overlay={
                                            <Menu>
                                              {(items.status === 'Inactive') && (
                                                <Menu.Item key={`2`} onClick={()=>handleChangeStatus(items._id,'Active') } >
                                                  <FontAwesomeIcon icon={faThumbsUp} /> <span className="show_span">Active</span>
                                                </Menu.Item>
                                              )}
                                              {items.status === 'Active' && (
                                                <Menu.Item key={`3`} onClick={() => handleChangeStatus(items._id,'Inactive')} >
                                                  <FontAwesomeIcon icon={faThumbsDown} /> <span className="show_span">Inactive</span>
                                                </Menu.Item>
                                              )}
                                              {items?.status === "Redeemed" && (
                                                <Menu.Item key={`4`} onClick={() => {
                                                  Modal.confirm({
                                                    title: 'Confirm Reverse',
                                                    content: 'Are you sure you want to reverse this redeemed ticket?',
                                                    okText: 'Yes, Reverse',
                                                    cancelText: 'Cancel',
                                                    okType: 'danger',
                                                    onOk() {
                                                      handleReverse(items._id);
                                                    },
                                                  });
                                                }} >
                                                  <FontAwesomeIcon icon={faRefresh} /> <span className="show_span">Reverse</span>
                                                </Menu.Item>
                                              )}
                                            </Menu>
                                          }
                                        >
                                          <FontAwesomeIcon icon={faEllipsis} />
                                        </Dropdown>
                                      ):("-")}
                                      
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={112} /> : <tr> 
                                <td colspan="11" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <p>{`${SKIP + 1} - ${LIMIT * currentPage} of ${totalDataCount}`}</p>
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value='' selected disabled>Select search field</option>
                  <option value='batch_id' selected={filter?.filter_by ==='batch_id'?true:false}>Batch No.</option>
                  <option value='order_no' selected={filter?.filter_by ==='order_no'?true:false}>Order No.</option>

                  <option value='seller_first_name' selected={filter?.filter_by ==='seller_first_name'?true:false}>Seller's First Name</option>
                  <option value='seller_last_name' selected={filter?.filter_by ==='seller_last_name'?true:false}>Seller's Last Name</option>
                  <option value='seller_mobile' selected={filter?.filter_by ==='seller_last_name'?true:false}>Seller's Mobile</option>

                  <option value='coupon_code' selected={filter?.filter_by ==='coupon_code'?true:false}>Coupon Code</option>
                  <option value='matching_code' selected={filter?.filter_by ==='matching_code'?true:false}>Matching Code</option>

                  <option value='winner_type' selected={filter?.filter_by ==='winner_type'?true:false}>Winner Type</option>
                  <option value='winning_amount' selected={filter?.filter_by ==='winning_amount'?true:false}>Winning Amount</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
    </>
  );
}
